import React from 'react';
import styled from 'styled-components';
import Votes from '../../../../Votes/containers/NonVirtualVotes';

const Wrapper = styled.div`
    flex: 2;
    margin: 0 16px 0 0;
    overflow: scroll;
    box-sizing: border-box;
    position: relative;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: 16px;
    margin-right: 24px;
`;

function LeftContent() {
    return (
        <Wrapper>
            <Votes />
        </Wrapper>
    );
}

LeftContent.propTypes = {};

export default LeftContent;
